class ajaxHelper {

    constructor() {}

    loadMorePosts(el) {
        var btn = $(el),
            posts = $('[data-id]'),
            container = $($(el).data('target'));

        var page = window.app.ajax.getUrlParam('currentPage');
        if (page === null || page == '') page = 1;

        btn.on('click', function (e) {
            e.preventDefault();
            btn.prop('disabled', true);
            //grab current IDS on page
            var posts = $('[data-id]'), postIDs = [];
            posts.each(function () {
                postIDs.push($(this).data('id'));
            });
            var data = {
                action: 'load_posts',
                posts: postIDs,
            };
            $.post('/wp-json/v5/posts', data, function (res) {
                if (res.html) {
                    container.append(res.html);
                } else {
                    btn.hide();
                }
                page++;
                var url = window.location;
                window.history.pushState({
                    page: page
                }, 'Blog Page ' + page, url.origin + url.pathname + '?currentPage=' + page);
                btn.prop('disabled', false);
            });
        });
    }

    getUrlParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    loadMoreProjects(el) {

        var btn = $(el),
            posts = $('[data-id]'),
            container = $($(el).data('target'));

        var page = window.app.ajax.getUrlParam('currentPage');
        if (page === null || page == '') page = 1;


        el.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('load more projects');

            console.log('e:', e);

            btn.prop('disabled', true);
            //grab current IDS on page
            var posts = $('[data-id]'), postIDs = [];

            posts.each(function () {
                postIDs.push($(this).data('id'));
            });

            console.log('postIDs', postIDs);

            var data = {
                action: 'get_data',
                posts: postIDs,
            };

            jQuery.ajax({
                type: "get",
                dataType: "json",
                url: '/wp-json/wp/v2/project',
                data: data,
                success: function(msg){
                    console.log(msg);
                }
            });
        });
    }
}

window.app.add('ajax', new ajaxHelper());